module.exports = __webpack_public_path__ + "c4a92e81c11437836f0db7feb547c7e5.svg";